// Brend wordmark — ikki rangli: "Avto" ko'k, "Daftar" amber. Faqat brend
// kontekstida ishlatiladi (sidebar, login). Body matnda emas.
export function BrandWordmark() {
  return (
    <>
      <span className="text-[#2D6BFF]">Avto</span>
      <span className="text-[#F5A623]">Daftar</span>
    </>
  );
}
